module.exports = __webpack_public_path__ + "img/kenyan-flag.310a638a.svg";